module.exports = __webpack_public_path__ + "static/Services-9cf83e6d4ec2892d528fb4c70737404e.jpg";